<template>
    <div class="method-statement-form row">
        <div class="col-12 col-md-6">
            <div class="form-group">
                <label class="form-label" for="user-first-name">First Name</label>
                <input type="text" class="form-control" id="user-first-name" placeholder="First Name" v-model="userData.first_name">
            </div>
        </div>

        <div class="col-12 col-md-6">
            <div class="form-group">
                <label class="form-label" for="user-last-name">Last Name</label>
                <input type="text" class="form-control" id="user-last-name" placeholder="Last Name" v-model="userData.last_name">
            </div>
        </div>

        <div class="col-12 col-md-6">
            <div class="form-group">
                <label class="form-label" for="user-email">Email Address</label>
                <input type="text" class="form-control" id="user-email" placeholder="Email Address" v-model="userData.email">
            </div>
        </div>

		<div class="col-12">
			<div class="" v-if="saving">
				<loader></loader>
			</div>
		</div>
    </div>
</template>

<script>
    import Loader from "../../general_components/Loader";
	export default {
        name: "UserCreateEditPage",
		components: {Loader},
		props: {
            submit_url: {
                type: String,
                required: true
            },
            back_url: {
                type: String,
                required: true
            },
            user: {
                type: Object,
                default: () => { return {} }
            }
        },

        data(){
            return {
                userData: {
                    first_name: '',
                    last_name: '',
                    email: ''
                },

                saving: false,
                errors: []
            }
        },

        beforeMount() {
        	if (this.user)
				this.userData =  Object.assign({}, this.user);

			window.addEventListener('LAYOUT:primary_button', this.save);
			window.addEventListener('LAYOUT:cancel_button', this.cancel);
        },

        methods: {
            save: function(){
                this.errors = [];

                if (this.saving){
					return false;
                }

				this.saving = true;

                axios({
                    'method': this.user ? 'patch' : 'post',
                    'url': this.submit_url,
                    'data': this.userData
                }).then(() => {
                    this.saving = false;
                    window.location.href = this.back_url;
                }).catch((error) => {
                    if(error.response.data.errors !== undefined){
                        Object.values(error.response.data.errors).forEach((err, i) => {
                            this.errors.push(`<li>${err[0]}</li>`);
                        });
                    }

                    if (this.errors.length >= 2) {
                        Vue.$toast.open({
                            message: `There were ${this.errors.length} errors: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    } else if (this.errors.length === 1) {
                        Vue.$toast.open({
                            message: `There was an error: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    }

                    this.saving = false;
                });
            },

			cancel(){
            	window.location.href = this.back_url;
			}
        }
    }
</script>
